import EmailSubscription from './email-subscription';
import Audio from './audio';
import TableOfContents from './table-of-contents';
import PodcastSubscription from './podcast-subscription';
import Video from './video';

export default class Placeholders {
  emailSubscription = new EmailSubscription();
  audio = new Audio();
  video = new Video();
  tableOfContents = new TableOfContents();
  podcastSubscription = new PodcastSubscription();

  initialize = () => {
    this.emailSubscription.initialize();
    this.audio.initialize();
    this.video.initialize();
    this.tableOfContents.initialize();
    this.podcastSubscription.initialize();
  };
}
